module.exports = __webpack_public_path__ + "media/Shva_illustration.98a5acf0.mp3";